import {ValueObject} from '@s-ui/domain'

export class NewsRatingRequestValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.articleId
   */
}
